/**
 * Deriva el rubro ("auto" | "moto") a partir del primer segmento de la URL actual.
 * El flujo de emisión es compartido entre auto y moto; cada paso navega usando
 * este rubro para mantenerse dentro de su propio prefijo (/auto/... o /moto/...).
 * Por defecto devuelve "auto" para no alterar el comportamiento previo.
 */
export const getRubroFromPath = (pathname: string = window.location.pathname): string => {
  const primerSegmento = pathname.split("/").filter(Boolean)[0];
  return primerSegmento === "moto" ? "moto" : "auto";
};

const conCompania = (rubro: string, paso: string, compania?: string): string =>
  compania
    ? `/${rubro}/cotizacion/${compania}/${paso}`
    : `/${rubro}/cotizacion/${paso}`;

/**
 * Devuelve la URL del primer paso del flujo de cotización según rubro.
 * Auto entra por la patente; moto no tiene datacar y entra eligiendo la moto.
 */
export const getInicioCotizacion = (rubro: string, compania?: string): string =>
  conCompania(rubro, rubro === "moto" ? "vehiculo" : "patente", compania);

/**
 * Paso donde se carga el vehículo a mano. En Moto es un paso propio; en Auto
 * el vehículo se completa dentro del paso de datos, cuando la patente no trajo
 * nada o se entró sin patente.
 */
export const getPasoVehiculo = (rubro: string, compania?: string): string =>
  rubro === "moto"
    ? conCompania(rubro, "vehiculo", compania)
    : conCompania(rubro, "datos", compania);

/**
 * Paso final del cotizador: todo lo que falta en una sola pantalla. Reemplaza
 * los slides de una pregunta por pantalla (nombre, apellido, email, teléfono,
 * fecha de nacimiento, género, provincia/localidad y cuándo asegura).
 */
export const getPasoDatos = (rubro: string, compania?: string): string =>
  conCompania(rubro, "datos", compania);
